<template>
  <BaseIndex ref="baseIndex" :modelNameSingular="modelNameSingular" :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading" :loading="loading" :table-headers="tableHeaders" :table-items="payments"
    v-if="renderComponent" :maskFields="maskFields" :indexNested="true" :disablePagination="true" :showExpand="true"
    :containTopToolbar="containTopToolbar" :hasTableTitle="hasTableTitle" :tableTitle="tableTitle"
    :customExpandIcon="true" @row-clicked="handleRowClicked" class="row-pointer" :containSearchBar="false">
    <template slot="new" v-if="!readOnly">
      <New @entry-created="entryCreated" :totals="paymentTotals"
      :extraData2="extraData"
        :createButtonDisabled="((modelType == 'Sale' || modelType == 'Purchase') && totalPayment >= paymentLimit)"
        :typeText="typeText" :modelType="modelType" :modelNameSingular="modelNameSingular" />
    </template>

    <template slot="show" slot-scope="{ item }">
      <Edit :entry="item" :readOnly="true" :totals="paymentTotals" :typeText="typeText" :modelType="modelType"
        :modelNameSingular="modelNameSingular" />
    </template>

    <template slot="edit" v-if="!readOnly" slot-scope="{ item }">
      <Edit :entry="item" :totals="paymentTotals" @entry-updated="entryUpdated" :typeText="typeText"
        :modelType="modelType" :modelNameSingular="modelNameSingular" :isEdit="true" />
    </template>

    <template slot="delete" v-if="!readOnly" slot-scope="{ item }">
      <Delete :entry="item" @entry-destroyed="entryDeleted" :typeText="typeText" :modelType="modelType"
        :modelNameSingular="modelNameSingular" />
    </template>

    <template v-slot:expand="{ item, headers }">
      <td :colspan="headers.length"
        :class="'px-0 px-sm-2 px-md-6 mt-3 ' + ($vuetify.breakpoint.smAndDown ? 'v-data-table__mobile-row' : '')">
        <InstallmentIndex v-if="true" :loading="false" :installments.sync="item.installmentsAttributes"
          :installmentsTotal="item.value" class="mt-6" :modelType="modelType"
          @installment-update="$emit('installment-update', $event)" :readOnly="readOnly" />
      </td>
      <!-- <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :typeText="typeText"
        :modelType="modelType"
      /> -->
    </template>

    <template v-slot:expandColumn="{ item, isExpanded, expand }">
      <v-btn text color="primary" v-if="!isExpanded">Ver Parcelas</v-btn>
      <v-btn text color="primary" v-if="isExpanded"><v-icon left>mdi-eye-off</v-icon> Parcelas</v-btn>
    </template>

    <template slot="tableFooter" v-if="paymentsSummary">
      <tr class="d-none d-md-table-row">
        <td>
          <strong class="title">
            Total:
          </strong>
        </td>
        <td class="text-xs-right title" colspan="7">
          <strong class="mr-5">{{ this.totalPayment | formatCurrency }}</strong>
          {{ modelType == "Sale" || modelType == "Purchase" || modelType == "CashOutflowInstallment" || modelType ==
            "CashInflowInstallment" ? "Restante:" : ""}}
          <strong
            v-if="modelType == 'Sale' || modelType == 'Purchase' || modelType == 'CashOutflowInstallment' || modelType == 'CashInflowInstallment'"
            :class="(this.paymentLimit - this.totalPayment) > 0 ? 'red--text' : 'green--text'">
            {{ _.round(this.paymentLimit - this.totalPayment, 2) | formatCurrency }}
          </strong>
        </td>
      </tr>

      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.totalPayment | formatCurrency }}</strong></div>
        </td>

        <td class="v-data-table__mobile-row"
          v-if="modelType == 'Sale' || modelType == 'Purchase' || modelType == 'CashOutflowInstallment' || modelType == 'CashInflowInstallment'">
          <div class="v-data-table__mobile-row__header">Restante</div>
          <div class="v-data-table__mobile-row__cell"><strong
              :class="(this.paymentLimit - this.totalPayment) > 0 ? 'red--text' : 'green--text'">{{
                _.round(this.paymentLimit - this.totalPayment, 2) | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";
import InstallmentIndex from "@models/installments/index.vue"

export default {
  name: "PaymentIndex",
  data() {
    return {
      loading: false,
      pageLoading: false,
      renderComponent: true,
      tableHeaders: [
        { text: "#", align: "left", sortable: true, value: "code" },
        { text: "R$", align: "left", sortable: true, value: "value" },
        { text: "Forma de Pagamento", align: "left", sortable: true, value: "paymentMethod.name" },
        { text: "Conta", align: "left", sortable: true, value: "bankAccount.name" },
        { text: "Condição", align: "left", sortable: true, value: "paymentCondition.description" },
        { text: "Intervalo", align: "left", sortable: true, value: "installmentsInterval.description" },
        { text: "1ª Parcela", align: "left", sortable: true, value: "initialDate" },
        // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true },
        { text: "Ações", value: "action", sortable: false },
        { text: "Parcelas", value: "data-table-expand", sortable: false }
      ],
      maskFields: [
        { field: 'value', mask: 'currency' },
        { field: 'initialDate', mask: 'date' },
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
    InstallmentIndex: InstallmentIndex
  },
  props: {
    extraData: {
      type: Object,
      default: null,
    },
    modelType: {
      type: String,
    },
    payments: {
      type: Array,
      default: []
    },
    totalPayment: {
      type: Number,
      default: 0
    },
    paymentLimit: {
      type: Number,
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    paymentsSummary: {
      type: Boolean,
      default: true
    },
    containTopToolbar: {
      type: Boolean,
      default: true
    },
    hasTableTitle: {
      type: Boolean,
      default: false
    },
    tableTitle: {
      type: String
    },
    modelNameSingular: {
      type: String,
      default: "Pagamento"
    },
    modelNamePlural: {
      type: String,
      default: "Pagamentos"
    },
  },
  mounted() {
  },
  computed: {
    paymentTotals: function () {
      return { payments: this.totalPayment, limit: this.paymentLimit };
    },
    typeText: function () {
      console.log(this.modelType);
      if (this.modelType == "Sale" || this.modelType == "CashInflow" || this.modelType == "CashInflowInstallment") {
        return "Recebimento";
      } else if (this.modelType == "Purchase" || this.modelType == "CashOutflow" || this.modelType == "CashOutflowInstallment") {
        return "Pagamento";
      }
    }
  },
  methods: {
    entryUpdated: function (editedEntry) {
      this.$refs.baseIndex.showConfirmationMessage(this.typeText + " atualizado com sucesso!");
      this.recalculateTotalPayment();
    },
    entryCreated: function (newlyEntry) {
      this.payments.push(newlyEntry);
      this.$refs.baseIndex.showConfirmationMessage(this.typeText + " adicionado com sucesso!");
      this.recalculateTotalPayment();
    },
    entryDeleted: function (deletedEntry) {
      // console.log("Deletou o deletedEntry", deletedEntry);
      this.$refs.baseIndex.showConfirmationMessage(this.typeText + " removido com sucesso!");
      this.recalculateTotalPayment();
    },
    recalculateTotalPayment: function () {
      var newTotalPayment = 0;
      for (var payment in this.payments) {
        if (this.payments[payment]._destroy) {
          continue;
        }
        newTotalPayment = _.round(newTotalPayment + parseFloat(this.payments[payment].value), 2);
      }
      this.$emit('update:totalPayment', newTotalPayment);
    },
    handleRowClicked: function (rowArguments) {
      // console.log("row click", rowArguments);
      if (rowArguments && rowArguments[1]) {
        rowArguments[1].expand(!rowArguments[1].isExpanded);
      }
    }
  }
};
</script>

<style lang="css" scoped>
.row-pointer>>>tbody tr :hover {
  cursor: pointer;
}
</style>
